// 빌드에 생성된 전체 라우트에서 현재 역할 서브트리만 골라 prefix를 떼고 루트로 승격한다
import type { RouteRecordRaw } from 'vue-router'
import type { SiteKey } from './site'

export function selectSiteRoutes(routes: RouteRecordRaw[], site: SiteKey): RouteRecordRaw[] {
  const prefix = `/${site}`
  return routes
    .filter(r => r.path === prefix || r.path.startsWith(prefix + '/'))
    .map(r => ({ ...r, path: r.path.slice(prefix.length) || '/' }))
}
